import { Link } from "react-router-dom";

type Props = {
  icon: string;
  title: string;
  subtitle?: string;
  action?: { label: string; to: string };
};

export default function SectionHeading({ icon, title, subtitle, action }: Props) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
          <i className={`${icon} text-primary-500`}></i>
          {title}
        </h2>
        {subtitle ? <p className="mt-1 text-sm text-foreground-600">{subtitle}</p> : null}
      </div>
      {action ? (
        <Link
          to={action.to}
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {action.label}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      ) : null}
    </div>
  );
}